export const WorkWithUsBtn = () => {
  return (
    <>
      <a
        href="https://forms.gle/Q3BcFPzi8qGZVvH7A"
        target="_blank"
        rel="noreferrer"
        className="text-decoration-none"
      >
        <button class="WorkWithUsBtn btnText mx-1 mt-2">
          {" "}
          <b>Work With Us </b>
        </button>
      </a>
    </>
  );
};
